import { render, staticRenderFns } from "./friends-details.vue?vue&type=template&id=faa205d0&scoped=true"
import script from "./friends-details.vue?vue&type=script&lang=js"
export * from "./friends-details.vue?vue&type=script&lang=js"
import style0 from "./friends-details.vue?vue&type=style&index=0&id=faa205d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa205d0",
  null
  
)

export default component.exports